import UserInformationFormContainer from './containers/UserInformationFormContainer';

export default UserInformationFormContainer;
